<template>
  <div v-if="loading" style="height: 100%;" class="d-flex flex-column justify-center align-center">
    <v-progress-circular
      :width="3"
      :size="60"
      color="blue"
      indeterminate
    ></v-progress-circular>
    <strong class="mt-5">Carregando informações...</strong>
  </div>
  <div v-else>
    <zp-modal-update v-model="formEdit"></zp-modal-update>
    <v-toolbar flat>
      <v-toolbar-title>Programa de afiliados</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text @click="edit()">
        <v-icon>mdi-cog</v-icon>
        <span class="ml-2">Configurações</span>
      </v-btn>
    </v-toolbar>
    <div class="d-flex flex-column align-center justify-center mt-5">
      <div class="d-flex flex-column">
        <span>Seu link de afiliado</span>
        <div class="d-flex align-center">
          <h1 class="light-blue--text text--accent-4">https://zprs.in/{{user.link_affiliate.shortened}}</h1>
          <v-btn class="ml-1" icon @click="copyStringToClipboard(`https://zprs.in/${user.link_affiliate.shortened}`)">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-card outlined class="pa-3 mt-10">
      <v-row>
        <v-col cols="12" md="3">
          <div class="d-flex justify-center">
            <div class="d-flex flex-column">
              <span class="font-weight-bold">Cliques</span>
              <div class="d-flex align-end mt-2" style="line-height: 1">
                <span class="font-weight-medium" style="font-size: 1.5em">{{clicks.last30days | number}}</span>
                <span>/{{clicks.all | number}}</span>
              </div>
              <span class="caption mt-2">ÚLTIMOS 30 DIAS / TODO O PERÍODO</span>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="d-flex justify-center">
            <div class="d-flex flex-column">
              <span class="font-weight-bold">Leads</span>
              <div class="d-flex align-end mt-2" style="line-height: 1">
                <span class="font-weight-medium" style="font-size: 1.5em">{{analytics.leads.last30days | number}}</span>
                <span>/{{analytics.leads.all | number}}</span>
              </div>
              <span class="caption mt-2">ÚLTIMOS 30 DIAS / TODO O PERÍODO</span>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="d-flex justify-center">
            <div class="d-flex flex-column">
              <span class="font-weight-bold">Clientes</span>
              <div class="d-flex align-end mt-2" style="line-height: 1">
                <span class="font-weight-medium" style="font-size: 1.5em">{{analytics.customers.last30days | number}}</span>
                <span>/{{analytics.customers.all | number}}</span>
              </div>
              <span class="caption mt-2">ÚLTIMOS 30 DIAS / TODO O PERÍODO</span>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="d-flex justify-center">
            <div class="d-flex flex-column">
              <span class="font-weight-bold">Receita</span>
              <div class="mt-1 font-weight-medium" style="font-size: 1.5em">
                {{analytics.amount | currency}}
              </div>
              <span class="caption mt-1">PREVISÃO</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card outlined class="mt-5 mb-10">
      <v-card-title>Acompanhamento de indicadores</v-card-title>
      <div class="pa-3">
        <apexchart type="line" height="300" :options="chartOptions" :series="chartData.values"></apexchart>
      </div>
    </v-card>
    <v-snackbar v-model="copied" :timeout="2000">
      Link copiado para área de transferência
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" small text v-bind="attrs" @click="copied = false">
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

import ZpModalUpdate from '../components/Affiliate/Update'

export default {
  components: {
    ZpModalUpdate
  },
  data () {
    return {
      formInsert: false,
      formEdit: false,
      search: '',
      loading: true,
      copied: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    clicks () {
      let data = { last30days: 0, all: 0 }

      if (!this.user.link_affiliate) {
        return data
      }

      data = this.user.link_affiliate.clicks.reduce((data, item) => {
        data.all += item.redirects || 0

        if (moment(item.created_at).isAfter(moment().subtract(30, 'days'))) {
          data.last30days += item.redirects || 0
        }

        return data
      }, data)

      return data
    },
    analytics () {
      let analytics = {
        leads: { last30days: 0, all: 0 },
        customers: { last30days: 0, all: 0 },
        amount: 0
      }

      if (!this.user.affiliate_analytics) {
        return analytics
      }

      analytics.amount = this.user.affiliate_analytics.amount || 0

      analytics.leads = this.user.affiliate_analytics.leads.reduce((data, item) => {
        data.all += item.count || 0

        if (moment(item.date).isAfter(moment().subtract(30, 'days'))) {
          data.last30days += item.count || 0
        }

        return data
      }, analytics.leads)

      analytics.customers = this.user.affiliate_analytics.customers.reduce((data, item) => {
        data.all += item.count || 0

        if (moment(item.date).isAfter(moment().subtract(30, 'days'))) {
          data.last30days += item.count || 0
        }

        return data
      }, analytics.customers)

      return analytics
    },
    chartOptions () {
      return {
        chart: {
          height: 350,
          type: 'line',
        },
        dataLabels: {
          enabled: true,
          formatter: this.$options.filters.number
        },
        colors: ['#F7D15E', '#803BE8', '#00C57E'],
        stroke: {
          width: this.chartData.labels.map(() => 3),
          curve: 'smooth'
        },
        xaxis: {
          categories: this.chartData.labels
        },
        yaxis: [{
          title: {
            text: 'Volume',
          },
          labels: {
            formatter: this.$options.filters.number
          }
        }]
      }
    },
    chartData () {
      const period = []

      let date = moment().subtract(30, 'days')

      while (date.valueOf() <= moment().valueOf()) {
        period.push(date.format('DD/MM/YYYY'))
        date.add(1, 'days')
      }

      const data = []

      const clicks = this.user.link_affiliate.clicks.reduce((data, item) => {
        const date = moment(item.created_at).format('DD/MM/YYYY')
        data[date] = data[date] || 0
        data[date] += item.redirects || 0
        return data
      }, {})

      data.push({
        name: 'Cliques',
        type: 'line',
        data: period.map(date => clicks[date] || 0)
      })

      const leads = this.user.affiliate_analytics.leads.reduce((data, item) => {
        const date = moment(item.date).format('DD/MM/YYYY')
        data[date] = data[date] || 0
        data[date] += item.count || 0
        return data
      }, {})

      data.push({
        name: 'Leads',
        type: 'line',
        data: period.map(date => leads[date] || 0)
      })

      const customers = this.user.affiliate_analytics.customers.reduce((data, item) => {
        const date = moment(item.date).format('DD/MM/YYYY')
        data[date] = data[date] || 0
        data[date] += item.count || 0
        return data
      }, {})

      data.push({
        name: 'Clientes',
        type: 'line',
        data: period.map(date => customers[date] || 0)
      })

      return {
        labels: period.map(item => item.substr(0, 5)),
        values: data
      }
    }
  },
  mounted () {
    if (!this.user.affiliate) {
      return this.$router.push('/links')
    }

    this.index()
  },
  methods: {
    async index () {
      this.loading = true
      await this.$store.dispatch('auth/fetchAffiliate')
      this.loading = false
    },
    edit () {
      this.formEdit = true
    },
    copyStringToClipboard (str) {
      const el = document.createElement('textarea')
      el.value = str
      el.setAttribute('readonly', '')
      el.style = { position: 'absolute', left: '-9999px' }
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.copied = true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>